module.exports = __webpack_public_path__ + "media/images/front/icon_plus_wt-13ee8d9a69811cca22774eb810834b89.png";